import Avatar, { genConfig } from 'funifier-nice-avatar'
import {useState, useEffect} from 'react'
import { BiUser } from 'react-icons/bi';
import { getUserProfile } from '../../../services/profile.service'
import { User } from '../../../types'

interface AvatarByIdProps {
  size: number,
  id: string
}

export default function AvatarComponent({ size, id }: AvatarByIdProps) {
  const [user, setUser] = useState<User | null>(null)

  useEffect(() => {
    const fetchAvatar = async () => {
      const user = await getUserProfile(id)
      setUser(user)
    }
    fetchAvatar()
  }, [id])


  return (
    <>
      {user?.extra?.avatar ? (
        <Avatar
          style={{ width: size, height: size }}
          {...genConfig(user.extra.avatar)}
        />
      ) : user?.image?.medium?.url ? (
        <img src={user.image.medium.url} alt={user.name} style={{ width: size, height: size }} className="h-full w-full block object-cover" />
      ) : (
        <BiUser style={{ width: size, height: size }} className="bg-white" />
      )}
    </>
  )
}
